/**
 * Homepage text constants
 */

export const TOP_BAR = {
  SEARCH_PLACEHOLDER: "What are you looking for?",
  UPGRADE: "Upgrade",
} as const;

export const UPLOAD_DOWNLOAD = {
  TITLE: "Let's Create Clipz..",
  SUBTITLE_PREFIX: "Upload",
  SUBTITLE_SUFFIX: "or Drop your files here",
  PROJECT_TITLE_PLACEHOLDER: "Project Title",
  GET_STARTED: "Get Started",
  UPLOADING: "Uploading",
  ETA_LEFT: "left",
  ETA_FINISHING_MESSAGES: [
    "Finalizing upload…",
    "Securing your file…",
    "Almost there…",
  ],
} as const;

export const MAIN_SECTION = {
  TITLE: "Welcome to CherryClipz",
} as const;
